import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
  {
    id: 'types',
    heading: '1. Types of Cookies Used',
    body: [
      'Aina Suite limits the use of cookies to those strictly necessary for operation and performance. We use:',
    ],
    list: [
      { label: 'Essential Cookies', text: 'These are mandatory for the core functionality and security of the platform.' },
      { label: 'Analytics Cookies', text: 'These help us understand how the Service is performing and where we can improve.' },
    ],
    subsections: [
      {
        body: ['We do not use advertising or marketing cookies.'],
      },
    ],
  },
  {
    id: 'essential',
    heading: '2. Essential Cookies',
    body: ['These cookies are required for the following purposes and cannot be disabled:'],
    list: [
      { label: 'Authentication', text: 'To verify your account and keep you logged in during your session.' },
      { label: 'Security & Encryption', text: 'To manage secure encryption sessions and protect your data.' },
      { label: 'Fraud Prevention', text: 'To detect and prevent unauthorized access or malicious activity.' },
    ],
  },
  {
    id: 'analytics',
    heading: '3. Analytics Cookies',
    body: ['We use analytics tools to help us improve Aina Suite by:'],
    list: [
      { label: 'Monitoring Stability', text: 'Identifying and fixing system errors or performance bottlenecks.' },
      { label: 'Understanding Usage', text: 'Analyzing general usage trends to refine our features.' },
    ],
    subsections: [
      {
        body: [
          'Where required by law, we will obtain your explicit consent before placing analytics cookies on your device.',
        ],
      },
    ],
  },
  {
    id: 'managing',
    heading: '4. Managing Cookies',
    body: ['You have the right to manage your cookie preferences:'],
    list: [
      { label: 'Browser Settings', text: 'Most web browsers allow you to control, block, or delete cookies through their settings.' },
      { label: 'Service Impact', text: 'Please note that disabling Essential Cookies will impair the functionality of Aina Suite and may prevent you from logging in or using the Service securely.' },
    ],
  },
];

const contact = {
  heading: 'Contact Information',
  body: (
    <>
      If you have any questions regarding our use of cookies, please contact us at <a href="mailto:hello@ainasuite.com">hello@ainasuite.com</a>.
    </>
  ),
};

export default function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      updated="May 12, 2026"
      intro={
        <>
          Welcome to Aina Suite (<a href="https://ainasuite.com/">https://ainasuite.com/</a>). This Cookie Policy explains how we use cookies and similar technologies to ensure our Service remains secure, functional, and efficient.
        </>
      }
      sections={sections}
      contact={contact}
    />
  );
}
